import {
    ClipboardDocumentIcon,
    BuildingOffice2Icon,
    UserCircleIcon,
    BriefcaseIcon
} from "@heroicons/react/24/outline";

const TicketReport = [
    {
        path: "reports",
        fullPath: "ticket/reports",
        exact: true,
        showChildren: true,
        sidebarMenu: true,
        displayName: "Reports",
        displayPath: "Ticket > Reports",
        icon: ClipboardDocumentIcon,
        children: [
            // Authority Balance Report
            {
                path: "authority-ticket-balance-report",
                fullPath: "ticket/reports/authority-ticket-balance-report",
                exact: true,
                showChildren: false,
                sidebarMenu: true,
                displayName: "Authority Ticket Balance Report",
                displayPath: "Ticket > Report > Authority Ticket Balance Report",
                icon: BriefcaseIcon,
                children: [
                    {
                        index: true,
                        async lazy() {
                            const component = await import(
                                "../../pages/Ticket/TicketReport/Authority"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                       // permissions: [""],
                    }
                ],
            },

            // Retailer Balance Report
            {
                path: "retailer-ticket-balance-report",
                fullPath: "ticket/reports/retailer-ticket-balance-report",
                exact: true,
                showChildren: false,
                sidebarMenu: true,
                displayName: "Retailer Ticket Balance Report",
                displayPath: "Ticket > Report > Retailer Ticket Balance Report",
                icon: UserCircleIcon,
                children: [
                    {
                        index: true,
                        async lazy() {
                            const component = await import(
                                "../../pages/Ticket/TicketReport/Retailer"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                       // permissions: [""],
                    }
                ],
            },

            // Counter Balance Report
            {
                path: "counter-ticket-balance-report",
                fullPath: "ticket/reports/counter-ticket-balance-report",
                exact: true,
                showChildren: false,
                sidebarMenu: true,
                displayName: "Counter Ticket Balance Report",
                displayPath: "Ticket > Report > Counter Ticket Balance Report",
                icon: BuildingOffice2Icon,
                children: [
                    {
                        index: true,
                        async lazy() {
                            const component = await import(
                                "../../pages/Ticket/TicketReport/Counter"
                            );
                            return {
                                Component: component.default,
                            };
                        },
                       // permissions: [""],
                    }
                ],
            },
        ],
    },
];

export default TicketReport;
